import React, { FunctionComponent } from 'react';
import { cn } from '@companion-professional/webutils';

interface HoverLabelCellProps {
  // children is the content shown in the cell (e.g. a short date or a truncated id).
  children?: React.ReactNode;

  // label is the text shown above the cell on hover (e.g. the full date or the untruncated id).  When it is empty, no
  // hover label is rendered.
  label?: React.ReactNode;

  // onClick is called when the cell is clicked (e.g. to open the checkup).
  onClick?: () => void;

  // className can be used to add additional (sizing) classes to the cell.
  className?: string;
}

// HoverLabelCell is a table cell that shows a small tooltip-styled label above its content when hovered.  It is a
// lightweight (CSS only) alternative to <Tooltip /> for dense table cells, styled to match the shared TooltipContent.
export const HoverLabelCell: FunctionComponent<HoverLabelCellProps> = ({ children, label, onClick, className }) => {
  return (
    <div onClick={onClick} className={cn('group relative cursor-pointer', className)}>
      {children}
      {label ? (
        <div
          className={
            'absolute bottom-full left-0 z-10 mb-1 hidden whitespace-nowrap rounded-lg bg-secondary px-2 py-1 ' +
            'text-xs text-on-secondary shadow-popover group-hover:block'
          }
        >
          {label}
        </div>
      ) : null}
    </div>
  );
};
